export default __webpack_public_path__ + "static/media/Vector 7.90bb69f8.svg";